import { Typography } from '@components';
import React, { FC } from 'react';
import { AlertTriangle, MessageSquare, ThumbsUp } from 'react-feather';
import LoadingSpinner from '../buttons/LoadingSpinner';
import Tag from '../tags/Tag';
import DateRange from '../typography/DateRange';
import Box from './Box';

type status = {
  status: null | 'Gesloten' | 'Open' | 'In behandeling';
};

interface sprintListItem {
  title: string;
  startDate: string;
  endDate: string;
  status: status;
  comments?: number;
  attachments?: number;
  important?: string;
  type?: string;
}

const SprintListItem: FC<sprintListItem> = ({
  title,
  status,
  startDate,
  endDate,
  important,
  type,
  comments,
}) => {
  const statusClass = {
    'In uitvoering': 'bg-green-100',
    'In behandeling': 'bg-green-100',
    Gesloten: 'bg-green-300',
    Open: 'bg-gray-100',
  };

  return (
    <div className="grid grid-cols-[20px_1fr]">
      <div className="h-full bg-gray-100 dark:bg-slate-900 w-1 relative flex flex-col items-center">
        <div
          className={`absolute left-0 top-0 w-1 h-full ${statusClass[status]}`}
        ></div>

        {status === 'Gesloten' && (
          <div className="bg-green-300 text-white rounded-full p-1 z-10 mt-auto mb-auto">
            <ThumbsUp size={14} />
          </div>
        )}
        {status === 'In uitvoering' ||
          (status === 'In behandeling' && (
            <div className="mt-auto mb-auto z-10">
              <LoadingSpinner stroke={'#00C950'} />
            </div>
          ))}
      </div>
      <div className="px-4 py-6 bg-white dark:bg-slate-900 rounded-xl mt-2 mb-2 border border-gray-100 dark:border-gray-800 cursor-pointer transition-shadow hover:shadow-xl ">
        <Box gridSize="grid-2" size="noSize" type="clean">
          <Typography tag="p" type="default">
            {title}
          </Typography>
          <div className="justify-self-end">
            <Tag label={status} style={status} lowercase />
          </div>
        </Box>

        <div className="flex flex-wrap items-center gap-2 mt-2">
          <DateRange start={startDate} end={endDate} />
          {Number(comments || 0) > 0 && (
            <Tag
              label={comments}
              icon={<MessageSquare size={16} />}
              style="neutral"
            />
          )}
          <Tag label={type} style={type && type} />
          {important && (
            <Tag
              label={important}
              style={important}
              icon={<AlertTriangle size={13} />}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SprintListItem;
